import { defineComponent as _defineComponent } from 'vue'
import BuilderEstimatorSummarySidebar from "./BuilderEstimatorSummarySidebar.vue";
  import BuilderEstimatorSummaryItem from "./BuilderEstimatorSummaryItem.vue";
  import type { IBuilderEstimatorFormData } from "@/types/BuilderEstimatorFormData";
  import { BuilderEstimatorSteps } from "@/enums/BuilderEstimatorSteps";
  import { computed } from "vue";
  import { SummaryUserSelectionFormData } from "@/types/BuilderEstimatorMapper";
  import { getAllSummaryItemsFromForm } from "@/helpers/builder/getAllSummaryItemsFromForm";
  import CustomizeHouseSlider from "../CustomizeHouseSlider.vue";
  // CustomizeHouseSlider
  
export default /*@__PURE__*/_defineComponent({
  __name: 'BuilderEstimatorSummaryDesktop',
  props: {
    builderLogo: {},
    formData: {},
    totalPrice: {},
    showSuccessMessage: { type: Boolean },
    isLoading: { type: Boolean }
  },
  emits: ["select-prev", "on-submit"],
  setup(__props: any, { expose: __expose, emit: __emit }) {
  __expose();

  const props = __props;

  const emit = __emit;

  const onSelectPrev = () => {
    emit("select-prev");
  };

  const onSubmit = (data: SummaryUserSelectionFormData) => {
    emit("on-submit", data);
  };

  const { allSummaryItems } = getAllSummaryItemsFromForm(props.formData);
  const userSelectionsToSliderImages = computed(() => {
    if (!props.formData) return [];

    return [
      ...props.formData[BuilderEstimatorSteps.SELECT_DESIGN].houseDesign
        .mainImages,
      props.formData[BuilderEstimatorSteps.SELECT_FACADE].facade?.url,
      props.formData[BuilderEstimatorSteps.SELECT_EXTERNAL_COLOURS]
        .externalColorScheme?.imagesUrls,
      props.formData[BuilderEstimatorSteps.SELECT_INTERNAL_COLOURS]
        .internalColorScheme?.imagesUrls,
    ]
      .flat()
      .filter(Boolean);
  });

const __returned__ = { props, emit, onSelectPrev, onSubmit, allSummaryItems, userSelectionsToSliderImages, BuilderEstimatorSummarySidebar, BuilderEstimatorSummaryItem, get BuilderEstimatorSteps() { return BuilderEstimatorSteps }, computed, get SummaryUserSelectionFormData() { return SummaryUserSelectionFormData }, get getAllSummaryItemsFromForm() { return getAllSummaryItemsFromForm }, CustomizeHouseSlider }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})